import HttpRequest from "./http_request";

class AuthProvider extends HttpRequest {
  SignIn(data) {
    return this.get_guest("/auth/login", data);
  }
  SignOut(data) {
    return this.get_guest("/auth/logout", data);
  }
  ForgotPassword(data) {
    return this.post_guest("/api/auth/forgotpassword", data);
  }
  ResetPassword(data) {
    return this.post_guest("/api/auth/resetpassword", data);
  }
  GetProfileMe(data){
    return this.get("person/own", data);
  }
  ChangeProfileMe(data) {
    return this.post("person/own", data);
  }
  ChangeProfileMePhoto(formData) {
    return this.postFormData("person/own", formData);
  }
  ChangeProfile(data) {
    return this.put("profile/" + id , data);
  }

  ChangePasswordMe(data) {
    return this.put("user/password/0", data);
  }

  ChangePassword(data) {
    return this.put("profile/password/" + id, data);
  }
}

export default AuthProvider